import type {
  FetchNotificationsDatabaseParams,
  NotificationsDatabaseQueryKey,
  NotificationsDatabaseQuerySuffix,
  UseGetNotificationsDatabaseProps,
} from "./notifications-database.type";
import type { NotificationDatabaseEntity } from "@/entities/notification-database";

import { useInfiniteList } from "@/hooks/queries";

import { NOTIFICATIONS_DATABASE_PER_PAGE } from "./notifications-database.constant";

export const useGetNotificationsDatabase = ({
  readState,
  queryKeySuffix,
}: UseGetNotificationsDatabaseProps = {}) => {
  const suffix: NotificationsDatabaseQuerySuffix =
    queryKeySuffix ?? readState ?? "all";
  const queryKey: NotificationsDatabaseQueryKey = ["notifications", suffix];

  const params: FetchNotificationsDatabaseParams = {
    "page[size]": NOTIFICATIONS_DATABASE_PER_PAGE,
    "filter[read_state]": readState,
  };

  const { data, ...queryResult } = useInfiniteList<NotificationDatabaseEntity>({
    endpoint: "user.notifications",
    queryKey,
    params,
  });

  return {
    notifications: data ?? [],
    ...queryResult,
  };
};

export const useGetNotificationsDatabaseUnreadCount = () => {
  const { notifications, isLoading } = useGetNotificationsDatabase({
    readState: "unread",
    queryKeySuffix: "unread_count",
  });

  return {
    unreadCount: notifications.length,
    isLoading,
  };
};
